export default "__VITE_ASSET__TY3xtlF2__"